import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import RegistrationLayout from '../../custom/components/templates/RegistrationLayout'
import { v4 as uuidv4 } from 'uuid'
import './registration.css'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import RadioBox from '../../product/components/atoms/RadioBox'
import { useFormik, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { mapData, calculateAge, handleRedirectInternal } from '../../product/common/components'
// import PhoneValidation from './phoneValidation'
import { useHistory } from 'react-router-dom'
import CheckBox from '../../product/components/atoms/CheckBox'
import { Link } from 'react-router-dom'
import AuthContext from '../../product/context/auth/authContext'
import CommonContext from '../../custom/context/common/commonContext'
import ProductCommonContext from '../../product/context/common/commonContext'
import UserContext from '../../product/context/user/userContext'
import { FilterFramesOutlined } from '@material-ui/icons'
import { Document } from 'react-pdf'
import { LOGO } from '../../Utils'
import { parse, isDate } from 'date-fns'
import StripeCustomerContext from '../../product/context/stripe/customer/customerContext'
import NorthCapitalContext from '../../product/context/payment/northcapital/northcapitalContext'
import KlaviyoContext from '../../custom/context/klaviyo/klaviyoContext'
import AlertContext from '../../product/context/alert/alertContext'
import SettingContext from '../../product/context/seller/setting/settingContext'
import BuyerContext from '../../product/context/buyer/buyerContext'

import Tooltip from '@material-ui/core/Tooltip'
import Loaders from '../../custom/components/molecules/Loaders'
import CustomPopover from '../../custom/components/atoms/Popover'
import { el } from 'date-fns/locale'
import Cryptos from '../../product/common/cryptos'
import { Button } from '@material-ui/core'
import CustomDialog from '../../custom/components/organisms/Dialog'
import { gtagEvent } from '../../custom/common/analytics'

let randomVariable = Math.random()

const Registration = (props) => {
    const authContext = useContext(AuthContext)
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)
    const [isSSN, setSSN] = useState(true)
    const [userType, setUserType] = useState(0)
    const [type, setType] = useState('')
    const [registerUser, setRegisteredUser] = useState(null)
    const [businessClassificationsList, setBusinessClassifications] = useState([])
    const [UserId, setUserId] = useState(null)
    const [currentCountry, setCurrentCountry] = useState()
    const [initialPopup, setInititalPopup] = useState(false)
    const { user, register, responseStatus, clearResponse, loadUser } = authContext
    const [toggleDialog, setToggleDialog] = useState(false)
    const buyerContext = useContext(BuyerContext)
    let {
        cancelttwbidTemp,
        responseStatus: responseStatusBid,
        clearResponse: clearResponseStatusBid,
    } = buyerContext
    const [popup, setPopup] = useState(false)

    const commonContext = useContext(CommonContext)
    const settingContext = useContext(SettingContext)
    const productCommonContext = useContext(ProductCommonContext)
    const { updateProfile, responseStatus: responseStatusUser } = useContext(UserContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const {
        configFeatures,
        createCustomer,
        dwollaCustomerResponse,
        businessClassifications,
        dwollabusinessClassifications,
    } = commonContext
    const { searchTable, searchTableAction, table_data } = settingContext
    const { static_page, getStaticPage, allCountries, allStates } = productCommonContext
    const { responseStatus: responseStatusStripeCustomer, createStripeCustomer } =
        useContext(StripeCustomerContext)
    const {
        onBoardEntity,
        onBoardIndividual,
        addCampaignContact,
        createEntity,
        createParty,
        responseStatus: responseStatusNorthCapital,
    } = useContext(NorthCapitalContext)
    const { updateProfileAfterRegistration, subscribeProfileToListAfterRegister2 } =
        useContext(KlaviyoContext)
    let [termsLink, setTermsLink] = useState([])
    let [submitCount, setSubmitCount] = useState('')
    let [zohoRecord, setZohoRecord] = useState({
        email: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        zoho_id: null,
        created_at: null,
    })
    const [currentRegistrationType, setCurrentRegistrationType] = useState(false)
    const [inType, setInType] = useState('SSN')

    const newRegistration = true

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    // const [phoneVerify, setPhoneVerify] = useState(false)
    // const [disable, setDisable] = useState(false)

    // const changePhoneVerify = () => {
    //     setPhoneVerify(!phoneVerify)
    // }

    // YUP Validation array to ensure all required fields are given values
    const validationArray = [
        Yup.object({
            user_type: Yup.number().required('Required!'),
            first_name: Yup.string().when('user_type', {
                is: 0,
                then: Yup.string()
                    .trim()
                    .matches(/^[0-9a-zA-Z ]*$/g, 'Some kind of special characters not allowed')
                    .max(250, 'Maximum 250 characters')
                    .required('Required!'),
            }),
            last_name: Yup.string().when('user_type', {
                is: 0,
                then: Yup.string()
                    .trim()
                    .matches(/^[0-9a-zA-Z ]*$/g, 'Some kind of special characters not allowed')
                    .max(250, 'Maximum 250 characters')
                    .required('Required!'),
            }),
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required!'),
            password: Yup.string()
                .matches(
                    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                    'Password must contain at least one lowercase letter, uppercase letter, number and special character',
                )
                .min(8, 'Minimum 8 characters')
                .required('Required'),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password')], 'Passwords not match')
                .required('Required!'),
        }),
    ]

    useEffect(() => {
        if (responseStatusNorthCapital) {
            if (
                responseStatusNorthCapital.from === 'createParty' ||
                responseStatusNorthCapital.from === 'createEntity'
            ) {
                if (responseStatusNorthCapital.status === 'success') {
                    loadUser()
                    setTimeout(() => {
                        if (localStorage.temp_user_id) {
                            handleRedirectInternal(history, 'verify')
                        } else if (localStorage.ttw_temp_user_id) {
                            handleRedirectInternal(history, 'verify')
                        } else {
                            formik.handleReset()
                            handleRedirectInternal(history, 'verify')
                        }
                    }, 1000)
                } else {
                    setIsLoading(false)
                }
            }
            if (responseStatusNorthCapital.from == 'addCampaignContact') {
                if (responseStatusNorthCapital.status === 'success') {
                    searchTableAction({
                        table: 'zoho_users_logs',
                        registered: 1,
                        updateKeys: 'email',
                        updateValues: `${formik.values.email}`,
                        noConfig: true,
                    })
                }
            }
        }
    }, [responseStatusNorthCapital])

    const createDwollaCustomer = (id) => {
        createCustomer({
            userType: userType,
            user_id: id,
        })
    }

    // Check response status is succesuful
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'register') {
                if (responseStatus.status === 'success') {
                    gtagEvent('new_registration_started', {
                        method: 'email',
                        email: formik.values.email || user?.email,
                    })
                    formik.values.Accept_Marketing = formik.values.market_opt === 1 ? true : false
                    formik.values.Email_Opt_Out = formik.values.market_opt ? false : true
                    formik.values.First_Name = formik.values.first_name
                    formik.values.Last_Name = formik.values.last_name
                    formik.values.Email = formik.values.email
                    formik.values.UTM_Source = formik.values.utm_source
                    formik.values.UTM_Medium = formik.values.utm_medium
                    formik.values.UTM_Campaign = formik.values.utm_campaign
                    formik.values.User_Type = formik.values.regType
                    formik.values.Pick_List_5 = formik.values.regType
                    addCampaignContact(formik.values, 'User', true, true)

                    if (
                        responseStatus?.data?.ttwRes &&
                        responseStatus.data?.ttwRes?.length &&
                        localStorage.ttw_temp_user_id
                    ) {
                        if (
                            responseStatus.data?.ttwRes[0]?.current_price &&
                            responseStatus.data?.ttwRes[0].current_price !=
                                responseStatus.data?.ttwRes[0].old_price
                        ) {
                            localStorage.setItem(
                                'bidIncrease',
                                JSON.stringify({
                                    proposed_amount: localStorage.share,
                                    id: localStorage.itemId,
                                    bidding_type: 'hard',
                                    proposed_qty: '',
                                    customBidData: {
                                        autopurchase: localStorage.autopurchase,
                                    },
                                    autopurchase: localStorage.autopurchase,
                                }),
                            )
                            localStorage.setItem(
                                'current_price',
                                responseStatus.data?.ttwRes[0].current_price,
                            )
                            localStorage.setItem(
                                'old_price',
                                responseStatus.data?.ttwRes[0].old_price,
                            )
                        }
                    }
                    if (userType == 1) {
                        createEntity(
                            {
                                firstName: formik.values.first_name,
                                lastName: formik.values.last_name,
                                emailAddress: formik.values.email,
                                user_id: responseStatus.data.userID,
                                phone: '+1',
                            },
                            true,
                        )
                    } else {
                        createParty(
                            {
                                firstName: formik.values.first_name,
                                lastName: formik.values.last_name,
                                emailAddress: formik.values.email,
                                user_id: responseStatus.data.userID,
                                phone: '+1',
                            },
                            true,
                        )
                    }
                    setUserId(responseStatus.data.userID)
                } else {
                    setIsLoading(false)
                }
            }
            clearResponse()
        }
    }, [responseStatus])

    useEffect(() => {
        if (dwollaCustomerResponse && Object.keys(dwollaCustomerResponse).length > 0 && UserId) {
            loadUser()
            createStripeUser(UserId)
            setIsLoading(false)
        }
        // else {
        //     setIsLoading(false)
        //     createStripeUser(UserId)
        // }
    }, [dwollaCustomerResponse])

    useEffect(() => {
        getStaticPage({ id: 'terms_of_use' })
        businessClassifications()
    }, [])

    useEffect(() => {
        if (dwollabusinessClassifications && dwollabusinessClassifications.length > 0)
            setBusinessClassifications(
                dwollabusinessClassifications[2]['_embedded']['industry-classifications'],
            )
    }, [dwollabusinessClassifications])

    useEffect(() => {
        setTermsLink(static_page?.record?.file_path ? static_page.record.file_path : null)
    }, [static_page])

    useEffect(() => {
        formik.values.user_type = userType
    }, [userType])

    // Set Iniaital values
    const formik = useFormik({
        initialValues: {
            regType: 'individual',
            first_name: '',
            last_name: '',
            email: '',
            phone: '+1',
            market_opt: 1,
            is_marketing_opt: 1,
            utm_source: localStorage.getItem('utm_source') || '',
            utm_medium: localStorage.getItem('utm_medium') || '',
            utm_campaign: localStorage.getItem('utm_campaign') || '',
            Abandons_Registration: true,
            Type: 'Pre Registration',
            Relationship: ['Pre Registration'],
        },
        validationSchema: validationArray[0],
        onSubmit: (data) => {
            let values = data
            if (zohoRecord.email === values.email) {
                if (zohoRecord.utm_source && !values.utm_source) {
                    values.utm_source = zohoRecord.utm_source
                }
                if (zohoRecord.utm_medium && !values.utm_medium) {
                    values.utm_medium = zohoRecord.utm_medium
                }
                if (zohoRecord.utm_campaign && !values.utm_campaign) {
                    values.utm_campaign = zohoRecord.utm_campaign
                }

                if (zohoRecord.utm_source || zohoRecord.utm_medium || zohoRecord.utm_campaign) {
                    values.converted = 1
                }

                if (zohoRecord.created_at) {
                    const oneDayInMilliseconds = 24 * 60 * 60 * 1000 // Number of milliseconds in a day
                    const date = new Date() // Get current date and time
                    const currentTimeInMilliseconds = date.getTime() // Get current time in milliseconds

                    if (
                        currentTimeInMilliseconds - oneDayInMilliseconds >
                        new Date(zohoRecord.created_at).getTime()
                    ) {
                        // More than one day has passed
                        values.converted = 1
                    } else {
                        // Less than one day has passed
                        values.converted = 0
                    }
                }

                if (zohoRecord.zoho_id) {
                    values.zoho_id = zohoRecord.zoho_id
                }
                if (userType === 1) {
                    setIsLoading(true)
                    if (localStorage.temp_user_id) {
                        values.temp_user_id = localStorage.temp_user_id
                    }
                    if (localStorage.ttw_temp_user_id) {
                        values.ttw_temp_user_id = localStorage.ttw_temp_user_id
                    }
                    console.log(values, 'register values 1')

                    register(values)
                } else {
                    setIsLoading(true)
                    if (localStorage.temp_user_id) {
                        values.temp_user_id = localStorage.temp_user_id
                    }
                    if (localStorage.ttw_temp_user_id) {
                        values.ttw_temp_user_id = localStorage.ttw_temp_user_id
                    }
                    console.log(values, 'register values 2')

                    register(values)
                }
            } else {
                randomVariable = Math.random()
                randomVariable = Math.random()
                searchTable(
                    {
                        table: 'zoho_users_logs',
                        page: 1,
                        limit: 2,
                        filters: {
                            category: {
                                value: values.email,
                                type: 'in',
                                field: 'zul.email',
                            },
                        },
                    },
                    randomVariable,
                )
            }
        },
    })

    useEffect(() => {
        if (formik.values.regType === 'individual') setUserType(0)
        else setUserType(1)
    }, [formik.values.regType])

    useEffect(() => {
        if (table_data.from === randomVariable) {
            if (table_data.records && table_data.records.length) {
                setZohoRecord({
                    email: table_data.records[0]?.email,
                    utm_source: table_data.records[0]?.utm_source,
                    utm_medium: table_data.records[0]?.utm_medium,
                    utm_campaign: table_data.records[0]?.utm_campaign,
                    zoho_id: table_data.records[0]?.id,
                    created_at: table_data.records[0]?.created_at,
                })
                formik.submitForm()
            } else {
                setZohoRecord({
                    email: formik.values.email,
                    utm_source: null,
                    utm_medium: null,
                    utm_campaign: null,
                    zoho_id: null,
                    created_at: null,
                })
                searchTable(
                    {
                        table: 'company_owners',
                        page: 1,
                        limit: 2,
                        filters: {
                            username: {
                                value: formik.values.email,
                                type: 'in',
                                field: 'co.email',
                            },
                        },
                    },
                    'checkcompanyowner',
                )
            }
        }

        if (table_data.from === 'checkcompanyowner') {
            if (table_data.records && table_data.records.length) {
                setAlert('Registration Failed! Email Already Exists.', 'error')
            } else {
                formik.submitForm()
            }
        }
    }, [table_data])

    useEffect(() => {
        if (localStorage.getItem('utm_source')) {
            formik.setFieldValue('utm_source', localStorage.getItem('utm_source'))
        }
    }, [localStorage.getItem('utm_source')])

    useEffect(() => {
        if (localStorage.getItem('utm_medium')) {
            formik.setFieldValue('utm_medium', localStorage.getItem('utm_medium'))
        }
    }, [localStorage.getItem('utm_medium')])

    useEffect(() => {
        if (localStorage.getItem('utm_campaign')) {
            formik.setFieldValue('utm_campaign', localStorage.getItem('utm_campaign'))
        }
    }, [localStorage.getItem('utm_campaign')])

    const registrationTypes = [
        {
            name: 'regType',
            label: 'Individual',
            id: 'individual',
            img: '/assets/svg/individual.svg',
        },
        {
            name: 'regType',
            label: 'Entity',
            id: 'company',
            img: '/assets/svg/entity.svg',
        },
    ]

    // Mapped over for individual registration fields
    const IndividualRegistration = [
        {
            label: 'First Name',
            name: 'first_name',
            type: 'text',
            placeholder: 'Enter your first name',
            class: `col-12 col-sm-6`,
            // autoFocus: true,
            formik: formik,
            upperLabel: true,
            errorMessage: 'Required',
        },
        {
            label: 'Last Name',
            name: 'last_name',
            type: 'text',
            placeholder: 'Enter your last name',
            class: `col-12 col-sm-6`,
            formik: formik,
            upperLabel: true,
            errorMessage: 'Required',
        },
        // {
        //     type: 'misc',
        //     class: 'col-12',
        //     content: (
        //         <div className="registerForm mb-0">
        //             <div className="infoWrapper">
        //                 <p>
        //                     <strong>Note</strong>: Enter your first name and last name as they
        //                     appear on your government ID.
        //                 </p>
        //             </div>
        //         </div>
        //     ),
        // },
        {
            label: 'Email Address',
            name: 'email',
            type: 'email',
            placeholder: 'Enter your email address',
            class: 'col-12 col-sm-8',
            formik: formik,
            upperLabel: true,
            errorMessage: 'Required',
        },
        {
            label: 'Password',
            name: 'password',
            type: 'password',
            placeholder: 'Enter your password',
            class: 'col-12 col-sm-6',
            formik: formik,
            helperText: 'Password must have minimum 8 characters',
            upperLabel: true,
            // errorMessage: 'Required',
        },
        {
            label: 'Confirm password',
            name: 'confirm_password',
            type: 'password',
            placeholder: 'Re enter your password',
            class: 'col-12 col-sm-6',
            formik: formik,
            upperLabel: true,
            // errorMessage: 'Required',
        },
    ]

    useEffect(() => {
        if (formik.values.domicile === 'non-resident') {
            formik.setFieldValue('domesticYN', 'international_account')
        } else {
            formik.setFieldValue('domesticYN', 'domestic_account')
        }
    }, [formik.values.domicile])

    useEffect(() => {
        setCurrentCountry(formik.values.country)
        if (formik.values.country) formik.setFieldValue('state', '')
        if (document.getElementById('register'))
            document.getElementById('register').className = 'active'
    }, [formik.values.country])

    useEffect(() => {
        if (responseStatusBid) {
            console.log(responseStatusBid, 'responseStatusBid')
            if (responseStatusBid.from === 'cancelttwbidTemp') {
                if (responseStatusBid.status === 'success') {
                    setAlert(responseStatusBid.message, responseStatusBid.status)
                    setPopup(false)
                    localStorage.removeItem('ttw_temp_user_id')
                    localStorage.removeItem('itemId')
                    localStorage.removeItem('itemTitle')
                    localStorage.removeItem('share')
                    handleRedirectInternal(history, '')
                } else {
                    setAlert(responseStatusBid.message, 'error')
                }
            }
            clearResponseStatusBid()
        }
    }, [responseStatusBid])

    const cancelTemp = () => {
        const id = uuidv4()
        if (localStorage.ttw_temp_user_id) {
            setPopup(true)
        }
    }

    const changeTempDialogStatus = () => {
        setPopup(!popup)
    }

    return (
        <RegistrationLayout cancelTemp={cancelTemp} activeStep={0}>
            <Loaders name="home" isLoading={isLoading} loop={1} className="defaultLoader" />
            <div className="loginWrapper p-5 h-100">
                <form className="registerForm mb-0 row">
                    <h3 className="mb-4">Create Account</h3>
                </form>

                <div className="rgLyrWrpr d-flex align-items-center justify-content-center">
                    <div className="vpStepper">
                        <div className="loginWrapper regLoginWrapper p-5 h-100">
                            <form className="registerForm mb-0 row" onSubmit={formik.handleSubmit}>
                                <div className="row w-100 registerRadio">
                                    <div className="RadioBox col-md-12 mt-3">
                                        <div>
                                            <label className="radioTitle">User Type</label>
                                            <div className="d-flex align-items-center">
                                                {registrationTypes.map((data, index) => (
                                                    <div className="regType mr-3" key={index}>
                                                        <input
                                                            type="radio"
                                                            name={data.name}
                                                            hidden
                                                            id={data.id}
                                                            onChange={formik.handleChange}
                                                            checked={
                                                                formik.values.regType == data.id
                                                            }
                                                            value={data.id}
                                                        />
                                                        <label htmlFor={data.id}>
                                                            <img src={data.img} alt="" />
                                                            <h5>{data.label}</h5>
                                                            <div className="radioIcon"></div>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-2 indiRegCnt">
                                    <div className="registerForm mb-0 ml-0 mr-0 col-12">
                                        <div className="infoWrapper">
                                            <p>
                                                <strong>Note</strong> : Enter your first name and
                                                last name as they appear on your government ID.
                                            </p>
                                        </div>
                                    </div>
                                    {Object.values(mapData(IndividualRegistration))}
                                    <div className="col-md-12 mt-2">
                                        <p className="markOptCheck">
                                            <small>
                                                {`By clicking Register, you agree to SongVest's`}{' '}
                                                <a
                                                    href="https://www.songvest.com/terms-of-use"
                                                    target="blank"
                                                >
                                                    Terms of Service
                                                </a>{' '}
                                                and{' '}
                                                <a
                                                    href="https://www.songvest.com/privacy-policy"
                                                    target="blank"
                                                >
                                                    Privacy Policy
                                                </a>
                                                .
                                            </small>
                                        </p>
                                    </div>
                                </div>
                                <div className="regActBox mt-2">
                                    <PrimaryButton
                                        id="register_button"
                                        label="REGISTER"
                                        type="submit"
                                        onClick={() => formik.handleSubmit}
                                    />
                                    <div className="rdrLnk">
                                        Already have an account?
                                        <Link className="ml-2" id="signin_link" to="/login">
                                            Login
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <CustomDialog
                    title=""
                    open={popup}
                    function={changeTempDialogStatus}
                    disableBackdropClick
                >
                    <h5>
                        Are you sure you want to cancel your bid for {''}
                        {localStorage.share} shares of {`"${localStorage.itemTitle}"`}
                    </h5>
                    <div className="actionWrapper">
                        <Button
                            onClick={() => {
                                setPopup(false)
                            }}
                        >
                            Cancel
                        </Button>
                        <PrimaryButton
                            onClick={() => {
                                cancelttwbidTemp({
                                    ttw_temp_user_id: localStorage.ttw_temp_user_id,
                                })
                            }}
                            type="button"
                            label="Yes"
                        />
                    </div>
                </CustomDialog>
            </div>
        </RegistrationLayout>
    )
}

export default Registration
